// This allows us to mock import.meta in tests by falling back to process.env
export const config = {
  // queryLambdaURL: import.meta.env?.VITE_QUERY_LAMBDA_URL || process.env.VITE_QUERY_LAMBDA_URL,
  queryLambdaURL: determineEnvironmentURL(),
  queryLambdaToken: import.meta.env?.VITE_QUERY_LAMBDA_TOKEN || process.env.VITE_QUERY_LAMBDA_TOKEN,
  serviceURL: import.meta.env?.VITE_SERVICE_URL || process.env.VITE_SERVICE_URL,
  casLoginBaseURL: import.meta.env?.VITE_CAS_LOGIN_BASE_URL || process.env.VITE_CAS_LOGIN_BASE_URL,
  casLogoutURL: import.meta.env?.VITE_CAS_LOGOUT_URL || process.env.VITE_CAS_LOGOUT_URL,
  casJwtIssuingLambdaURL: import.meta.env?.VITE_CAS_JWT_ISSUING_LAMBDA_URL || process.env.VITE_CAS_JWT_ISSUING_LAMBDA_URL,
  casProtectedBots:['panoptobotdemo'],
  wsEndpoint: import.meta.env?.VITE_WS_ENDPOINT || process.env.VITE_WS_ENDPOINT
 };

 function determineEnvironmentURL() {
  const url = window.location.href; // Gets the current URL of the browser
  if (url.includes("chatbot2.dev.umd.edu")) {
    // Specific URL for the 'dev 2' environment
    return "https://dx2ve2wmhb.execute-api.us-east-1.amazonaws.com";
  } else if (url.includes("chatbot.dev.umd.edu")) {
    // Specific URL for the 'dev' environment
    return "https://ixcukdm275.execute-api.us-east-1.amazonaws.com";
  } else {
    // Default URL from environment variables if available
    return import.meta.env?.VITE_QUERY_LAMBDA_URL || process.env.VITE_QUERY_LAMBDA_URL;
  }
}
